import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/anime";

interface AnimeCardProps {
  anime: Anime;
  showDescription?: boolean;
}

export default function AnimeCard({ anime, showDescription = true }: AnimeCardProps) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group card-hover block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={anime.cover}
          alt={`${anime.title} 动漫封面`}
          title={`${anime.title} 动漫在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-[11px] font-medium backdrop-blur-sm">
          {anime.status}
        </span>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-accent-500/90 text-background-50 text-[11px] font-semibold">
          {anime.rating.toFixed(1)}
        </span>
      </div>

      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
          {anime.title}
        </h3>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {anime.categories.slice(0, 2).map((c) => (
            <span
              key={c}
              className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap"
            >
              {c}
            </span>
          ))}
          <span className="px-2 py-0.5 rounded-full bg-background-100 text-foreground-600 text-[11px] whitespace-nowrap">
            {anime.region}
          </span>
        </div>
        {showDescription && (
          <p className="mt-2 text-xs text-foreground-600 line-clamp-2 leading-relaxed">
            {anime.description}
          </p>
        )}
        <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-live-line"></i>
            {anime.latestEpisode}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line"></i>
            {Math.round(anime.views / 1000)}k
          </span>
        </div>
      </div>
    </Link>
  );
}